/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const LlmTurnStep = zod
	.object({
		duration_ms: zod.number().describe('Duration in milliseconds'),
		finished_at: zod.iso.datetime({ offset: true }).describe('Step finish timestamp'),
		index: zod.number().describe('Step index within the trace'),
		kind: zod.enum(['llm_turn']),
		rationale: zod.string().nullable().describe('Agent rationale for this step'),
		started_at: zod.iso.datetime({ offset: true }).describe('Step start timestamp')
	})
	.describe('An LLM turn in the reasoning trace');

export type LlmTurnStep = zod.input<typeof LlmTurnStep>;
export type LlmTurnStepOutput = zod.output<typeof LlmTurnStep>;
